"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.propAccessor = exports.NA = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var case_evidence_mapping_1 = __importDefault(require("./case-evidence-mapping"));
var ui_common_2 = require("@codametrix/ui-common");
var getFeatureForSelection = ui_common_2.cmxArtifacts.getFeatureForSelection, isSingleSelection = ui_common_2.cmxArtifacts.isSingleSelection, isLinkable = ui_common_2.cmxArtifacts.isLinkable;
var isCategorical = ui_common_2.cmxTypeguards.isCategorical, isNgram = ui_common_2.cmxTypeguards.isNgram;
exports.NA = 'N/A';
var onlyType = function (items) {
    return items.filter(function (item) {
        var _a;
        var feature = getFeatureForSelection(item);
        return ((_a = (isSingleSelection(item) &&
            (isCategorical(feature) || isNgram(feature)))) !== null && _a !== void 0 ? _a : false);
    });
};
var propAccessor = function (detail, evidenceManager) {
    return function (propPath, altValue) {
        if (altValue === void 0) { altValue = exports.NA; }
        var prop = ui_common_1.objectUtils.get(detail, propPath, altValue);
        var evidenceKey = case_evidence_mapping_1["default"][propPath];
        // no evidence may be sought, if so, just return the value
        if (evidenceKey === undefined) {
            return prop !== null ? prop : altValue;
        }
        var notLinked = !isLinkable(evidenceKey);
        // check to see if we have any highlights
        var isHighlighted = evidenceManager.isHighlighted(evidenceKey);
        if (notLinked || !isHighlighted) {
            return prop !== null ? prop : altValue;
        }
        var isSelected = evidenceManager.isSelected(evidenceKey);
        var highlights = evidenceManager.getHighlights(evidenceKey);
        if (highlights === undefined) {
            return prop;
        }
        // deal with categorical evidence only at this time
        var categoricals = onlyType(highlights);
        if (!categoricals.length) {
            return prop;
        }
        // wrap the value in spans for particular codes
        var highlighted = prop;
        categoricals.forEach(function (categorical) {
            if (isSingleSelection(categorical) && !categorical.evidence) {
                return;
            }
            var styleClasses = [
                "evidence",
                'highlighted-text',
                {
                    'evidence-categorical': true,
                    'qa-evidence-categorical': true,
                    'evidence-active': isSelected,
                    'qa-evidence-active': isSelected
                },
                "evidence-".concat(categorical.codeType.toLowerCase())
            ];
            highlighted = ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: highlighted })));
        });
        return highlighted;
    };
};
exports.propAccessor = propAccessor;
//# sourceMappingURL=case-prop-accessor.js.map